import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=d0cf5ff2"
var script = {}
import style0 from "./thankyou.vue?vue&type=style&index=0&id=d0cf5ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports